import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import("@/views/Home"),
    },
    {
      path: '/paperlist',
      name: 'PaperList',
      component: () => import("@/views/PaperList"),
    },
    {
      path: '/paperinfo/:id',
      name: 'PaperInfo',
      component: () => import("@/views/PaperInfo"),
    },
    {
      path: '/commentpost',
      name: 'CommentPost',
      component: () => import("@/views/CommentPost"),
    },
    {
      path: "/news",
      name: "News",
      component: () => import("@/views/News")
    },
    {
      path: '/news/:id',
      name: 'NewsInfo',
      component: () => import('@/views/NewsInfo'),
      props: true
    },
  ]
})
